import App from '../../../vendor_core/core/src/App';
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import ErrorModel from "../../../vendor_core/core/src/model/ErrorModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import VendorSpinGetResultState from "../../../vendor_core/src/states/VendorSpinGetResultState";

export default class TRWSpinGetResultState extends VendorSpinGetResultState {
    public sendRequest(): void {
        if (!SpinModel.isInFreespins() && !SpinModel.isInRespins()) {
            SpinModel.spinFinished = false;
            this.exit();
        } else {
            CommandManager.execute(
                Commands.UPDATE_FREE_SPINS,
                SpinModel.freespinsNum.toString()
            );
            App.timeline.call(
                this.onResponse,
                [],
                this,
                App.timeline.time + 0.1
            );
        }
    }

    protected onResponse(data?: any) {
        this._canExit = true;

        SpinModel.update(data);
        ErrorModel.update(data);
        BetModel.update(data);

        this.exit();
    }
}
